import KibanaFilterModel from './osd-filter-model';
export default class ExistsFilterModel extends KibanaFilterModel {
    meta;
    exists;
    constructor(meta) {
        super(meta);
        this.meta = meta;
        this.exists = { field: meta.key ?? '' };
    }
}
//# sourceMappingURL=exists-filter-model.js.map